/** Shared Sustainable Investments path and map configuration */

export const HIH_FORUM_PATH = "/hih-investment-forum";

export const FAO_INVESTMENT_FORUM_URL =
  "https://www.fao.org/hand-in-hand/investment-forum-2026/en";

/** Prevents zooming out past a full-globe view */
export const MIN_ZOOM = 2;
export const MAX_ZOOM = 8;
export const DEFAULT_CENTER: [number, number] = [15, 15];
export const DEFAULT_ZOOM = 1.4;
export const COUNTRY_FOCUS_ZOOM = 4.5;
export const FLY_DURATION_MS = 1200;

export const MARKER_RADIUS_AT_MIN_ZOOM = 14;
export const MARKER_RADIUS_AT_MAX_ZOOM = 40;

export const HIT_LAYER = "hih-circles-hit";
export const VISUAL_LAYER = "hih-circles";
export const LABELS_LAYER = "hih-labels";
export const COUNTRIES_SOURCE = "hih-countries";
export const MARKER_LAYERS = [HIT_LAYER, VISUAL_LAYER, LABELS_LAYER] as const;

export const ACTIVE_COLOR = "#508FCC";
export const INACTIVE_COLOR = "#adb5bd";
export const HOVER_COLOR = "#274766";

/**
 * Basemap matching the FAO homepage globe (fao.org/home/en, #map):
 * ESRI World Ocean Base raster tiles.
 */
export const FAO_OCEAN_TILES =
  "https://server.arcgisonline.com/ArcGIS/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}";

/**
 * FAO serves glyphs from its own host but that endpoint is access-restricted,
 * so we keep using OpenFreeMap glyphs (Noto Sans Regular) for the marker labels.
 */
export const GLYPHS =
  "https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf";
